import React from 'react';
import { FadeIn } from './FadeIn';
import { Shield, Scale, Cloud, GitMerge, CheckSquare, Presentation } from 'lucide-react';
export function Expertise() {
  const pillars = [{
    icon: <Shield strokeWidth={1.25} className="w-7 h-7" data-id="element-102" />,
    title: 'Enterprise Risk Management',
    description: 'Designing comprehensive risk frameworks that protect institutional assets while enabling strategic growth and innovation.',
    color: '#00E5FF'
  }, {
    icon: <Scale strokeWidth={1.25} className="w-7 h-7" data-id="element-103" />,
    title: 'Regulatory Governance',
    description: 'Ensuring strict adherence to global mandates (SOX, MiFID, FATCA, FINMA) through modernized compliance architectures.',
    color: '#7C3AED'
  }, {
    icon: <Cloud strokeWidth={1.25} className="w-7 h-7" data-id="element-104" />,
    title: 'Tech & Cloud Risk',
    description: 'Mitigating vulnerabilities in large-scale technology transformations and secure cloud migrations across global operations.',
    color: '#E11D74'
  }, {
    icon: <GitMerge strokeWidth={1.25} className="w-7 h-7" data-id="element-105" />,
    title: 'Program Leadership',
    description: 'Directing $10M+ global portfolios, aligning cross-functional teams to deliver complex initiatives on time and within budget.',
    color: '#10B981'
  }, {
    icon: <CheckSquare strokeWidth={1.25} className="w-7 h-7" data-id="element-106" />,
    title: 'Audit & Control',
    description: 'Establishing rigorous internal controls and audit frameworks to proactively identify and remediate operational deficiencies.',
    color: '#FF6B35'
  }, {
    icon: <Presentation strokeWidth={1.25} className="w-7 h-7" data-id="element-107" />,
    title: 'Board Advisory',
    description: 'Translating complex risk data into actionable executive dashboards for C-suite and board-level decision making.',
    color: '#C8A96A'
  }];
  return <section id="expertise" className="relative py-24 md:py-32 bg-navy border-t border-white/5 overflow-hidden" data-id="element-108">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full opacity-15 blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(225,29,116,0.5) 0%, rgba(124,58,237,0.3) 40%, rgba(0,229,255,0) 70%)'
    }} data-id="element-109"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-110">
        <FadeIn data-id="element-111">
          <div className="mb-16 md:mb-20" data-id="element-112">
            <div className="text-xs uppercase tracking-widest font-medium mb-6" style={{
            background: 'linear-gradient(90deg, #E11D74, #C8A96A)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }} data-id="element-113">
              Core Expertise
            </div>
            <h3 className="text-3xl md:text-4xl lg:text-5xl font-serif text-softwhite max-w-3xl leading-tight" data-id="element-114">
              Strategic pillars of{' '}
              <span style={{
              background: 'linear-gradient(135deg, #E11D74, #7C3AED)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }} data-id="element-115">
                enterprise transformation
              </span>
              .
            </h3>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-id="element-116">
          {pillars.map((pillar, index) => <FadeIn key={index} delay={index * 0.08} data-id="element-117">
              <div className="group relative h-full p-8 md:p-10 rounded-2xl bg-white/[0.03] backdrop-blur-sm border border-white/10 hover:border-white/30 transition-all duration-500 overflow-hidden" data-id="element-118">
                <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full opacity-20 blur-2xl group-hover:opacity-60 transition-opacity duration-500" style={{
              background: `radial-gradient(circle, ${pillar.color} 0%, transparent 70%)`
            }} data-id="element-119"></div>
                <div className="relative mb-6" style={{
              color: pillar.color
            }} data-id="element-120">
                  {pillar.icon}
                </div>
                <h4 className="relative text-xl font-serif text-softwhite mb-3" data-id="element-121">
                  {pillar.title}
                </h4>
                <p className="relative text-softwhite/60 font-light leading-relaxed text-sm" data-id="element-122">
                  {pillar.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}